import React from 'react';

/* A function that returns a JSX element. */
export const ViewCabezeraMensajes = (props) => {
	/* Destructuring the props object. */
	const {nombreUsuario, phone, addres, closeMenuContacts} = props;

	/* Returning a JSX element. */
	return (
		<div className='cabezeraMensajes'>
			<div className='menuImagenNombreCabezeraMensajes'>
				<div className='contentButtonMenuContactos'>
					<div
						className='buttonMenuContactos centrador'
						onClick={closeMenuContacts}
					>
						<div className='svgButtonMenuContactos'>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='20'
								height='20'
								fill='currentColor'
								className='bi bi-list'
								viewBox='0 0 16 16'
							>
								<path
									fillRule='evenodd'
									d='M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z'
								/>
							</svg>
						</div>
					</div>
				</div>
				<div className='imagenNombreCabezeraMensajes'>
					<div className='imagenCabezeraMensajes'>
						<img
							src='../../assets/imagen_usuario.png'
							alt='imagen_usuarios'
						/>
					</div>
					<div className='centrador nombreImagenCabezeraMensajes'>
						<div>{nombreUsuario}</div>
					</div>
				</div>
			</div>

			<div className='phoneAddresCabezeraMensaje'>
				<div className='phoneMensajes datosCabezeraMensaje'>
					<div className='titleDatosCabezeraMensaje'>Phone</div>
					<div className='contentDatosCabezeraMensaje'>{phone}</div>
				</div>
				<div className='addresMensajes datosCabezeraMensaje'>
					<div className='titleDatosCabezeraMensaje'>Addres</div>
					<div className='contentDatosCabezeraMensaje'>{addres}</div>
				</div>
			</div>
		</div>
	);
};
